<app-chubb-header></app-chubb-header>
<app-chubb-topbar></app-chubb-topbar>
<div>
     <div class="cds-p-4">
        <div class="cds-block lg:cds-hidden cds-w-full cds-relative cds-touch-none" (mousedown)="onDragStart($event.clientX)"
          (mouseup)="onDragEnd($event.clientX)" (touchstart)="onDragStart($event.touches[0].clientX)"
          (touchend)="onTouchEnd($event)">
          @if (currentIndex === 0) {
            <div class="cds-w-full cds-transition-all">
              <chubb-card class="cds-w-full cds-shrink-0 lg:cds-w-auto">
                <h3>Policies in arrears</h3>
                <div class="pending-chart cds-flex cds-mt-[20px] cds-mb-[20px] cds-w-full cds-h-full cds-justify-center cds-items-center">
                  <chubb-chart-bar class="cds-max-w-[360px]" [value]="barchartData">
                  </chubb-chart-bar>
                </div>
              </chubb-card>
            </div>
              }
            
          @if (currentIndex === 1) {
            
            <div class="cds-w-full cds-transition-all">
                <chubb-card class="cds-w-full cds-shrink-0 lg:cds-w-auto">
                  <h3>Upcoming anniversaries</h3>
            
                  <div class="cds-flex cds-justify-center cds-items-center">
                    <chubb-chart-pie [width]="252" [height]="211" [value]="piechartData" [showLegend]="true" [legendWidth]="100" />
                  </div>
                </chubb-card>
                </div>
          }
          @if (currentIndex === 2) {
            <div class="cds-w-full cds-transition-all">
              <chubb-card class="pending-api-card cds-w-full cds-shrink-0 lg:cds-w-auto">
                <h3>In force policies</h3>
                <div>
                  <div class="cds-text-[#150F96] cds-flex cds-flex-row cds-w-full cds-justify-start cds-items-center cds-gap-[10px] cds-mb-[6px]">
                    <div class="total ">
                      <h1 class="cds-leading-[70px]">$12345.56</h1>
                      
                    </div>
                  </div>
                </div>
              </chubb-card>
            </div>
          }
          <div class="cds-flex cds-justify-center cds-mt-2">
            <button (click)="currentIndex = 0" class="cds-w-2 cds-h-2 cds-rounded-full cds-mx-1" [ngClass]="{
                      'cds-bg-blue-600': currentIndex === 0,
                      'cds-bg-gray-300': currentIndex !== 0,
                    }"></button>
            <button (click)="currentIndex = 1" class="cds-w-2 cds-h-2 cds-rounded-full cds-mx-1" [ngClass]="{
                      'cds-bg-blue-600': currentIndex === 1,
                      'cds-bg-gray-300': currentIndex !== 1,
                    }"></button>
            <button (click)="currentIndex = 2" class="cds-w-2 cds-h-2 cds-rounded-full cds-mx-1" [ngClass]="{
                      'cds-bg-blue-600': currentIndex === 2,
                      'cds-bg-gray-300': currentIndex !== 2,
                    }"></button>
          </div>
        </div>
        
        <div class="cds-hidden lg:cds-flex lg:cds-flex-row cds-gap-4 cds-w-full">
          <div class="cds-w-full">
              <chubb-card class="cds-w-full cds-h-full cds-shrink-0 lg:cds-w-auto">
                <h3 class="cds-mb-2">Policies in arrears</h3>
                <div class="cds-flex cds-justify-center">
                  <chubb-chart-bar class="cds-w-full cds-max-w-[480px]" [value]="barchartData" [width]="460" [height]="280" [paddingLeft]="55" [paddingRight]="30" [paddingTop]="28" [paddingBottom]="44">
                  </chubb-chart-bar>
                </div>
              </chubb-card>
          </div>
          <div class="cds-w-full">
              <chubb-card class="cds-w-full cds-h-full cds-shrink-0 lg:cds-w-auto">
                <h3>Upcoming anniversaries</h3>
                <div class="pending-chart">
                  <div class="cds-flex cds-items-center cds-justify-center cds-gap-6">
                        <chubb-chart-pie [width]="330" [height]="280" [value]="piechartData" [showLegend]="true" [legendWidth]="130" />
                    
                  </div>
                </div>
              </chubb-card>
          </div>
        
          <div class="cds-w-full">
              <chubb-card class="pending-api-card cds-justify-between cds-w-full cds-shrink-0 cds-h-full lg:cds-w-auto">
                <h3>In force policies</h3>
                <div>
                  <div class="cds-text-[#150F96] cds-flex cds-flex-row cds-w-full cds-justify-start cds-items-center cds-gap-[10px] cds-mb-[6px]">
                    <div class="total ">
                      <h1 class="cds-leading-[70px]">$12345.56</h1>
                    </div>
                  </div>
                </div>
              </chubb-card>
          </div>
        </div>
        <div>
          <div class="title-tabs cds-mt-[10px]  cds-cursor-pointer">
            <chubb-tabs
              [labels]="tabLabels"
              [active]="activeTabIndex"
              (tabClick)="tabClicked($event)"
            />
          </div>
        </div>
        <div class="cds-bg-white cds-p-4 cds-rounded cds-shadow cds-mb-4">
            <div class="cds-flex cds-gap-4" [ngClass]="viewType === 'table' ? 'cds-flex-col sm:cds-flex-row sm:cds-items-end' : 'cds-flex-col'">
            <div class="cds-flex cds-flex-col sm:cds-flex-row sm:cds-items-end cds-gap-4 cds-w-[600px]" [ngClass]="viewType === 'condensed' ? 'cds-mb-4' : ''">
              <div class="cds-flex cds-flex-col cds-gap-[10px] sm:cds-max-w-[300px] cds-w-full">
                <p>Search by name or policy number</p>
                <div #searchInput class="cds-h-[46px] cds-border cds-border-[#6F7175] cds-flex cds-flex-row cds-justify-start cds-items-center cds-gap-[10px] cds-px-[10px]">
                  <img src="/images/search.svg" />
                  <input class="cds-border-0 cds-w-full cds-text-base focus:cds-outline-none"
                    type="text"
                    placeholder="Start typing"
                    [(ngModel)]="searchTerm"
                  />
                </div>
              </div>
              <div class="cds-flex cds-flex-col cds-gap-[10px] sm:cds-max-w-[300px] cds-w-full">
                <p>Anniversary date</p>
                <cb-calendar
                  fieldVariant="minimal"
                  placeholder="MM/DD/YYYY - MM/DD/YYYY"
                  rangeSeparator="-"
                  selectionMode="range"
                ></cb-calendar>
              </div>
            </div>
            <!-- Row 2: sort by (condensed) + filter/export/view buttons -->
            <div class="cds-flex cds-flex-col sm:cds-flex-row sm:cds-items-end cds-gap-4" [ngClass]="viewType === 'table' ? 'sm:cds-ml-auto' : ''">
              @if (viewType === 'condensed') {
                <div class="cds-flex cds-flex-col cds-gap-[10px] sm:cds-max-w-[300px] cds-w-full">
                  <p>Sort by</p>
                  <div
                    [cbSelectChoice]="$any(selectChoice)"
                    colorTheme="default"
                    styleVariant="minimal"
                  >
                    <p-select
                      #selectChoice
                      [options]="[
                        { name: 'New York', code: 'NY' },
                        { name: 'Rome', code: 'RM' },
                        { name: 'London, the city to have a cup of tea(with an accent).', code: 'LDN' },
                        { name: 'Istanbul', code: 'IST'},
                        { name: 'Paris', code: 'PRS' },
                      ]"
                      optionLabel="name"
                      placeholder="Name"
                      inputId="#selectChoice"
                    ></p-select>
                  </div>
                </div>
              }
              <div class="cds-flex cds-flex-row cds-items-center cds-gap-[10px] cds-ml-auto">
                <div class="filter-button cds-flex cds-flex-row cds-justify-center cds-items-center cds-rounded cds-px-[10px] cds-border cds-border-[#D7D7D7] cds-gap-[4px] cds-h-[46px]">
                  Filter
                  <img src="/images/Filter.png" />
                </div>
                <div class="filter-button cds-flex cds-flex-row cds-justify-center cds-items-center cds-rounded cds-px-[10px] cds-border cds-border-[#D7D7D7] cds-gap-[4px] cds-h-[46px]">
                  <img src="/images/export.png" />
                </div>
                <div class="filter-switch cds-flex cds-flex-row cds-items-center cds-cursor-pointer">
                  <div
                    (click)="setView('table')"
                    class="filter-button cds-flex cds-flex-row cds-justify-center cds-items-center cds-rounded cds-px-[10px] cds-border cds-border-[#D7D7D7] cds-gap-[4px] cds-h-[46px] cds-pointer-events-none lg:cds-pointer-events-auto"
                    [ngClass]="viewType === 'table' ? 'cds-bg-[#e8e8e8]' : 'cd-bg-transparent'"
                  >
                    <img src="/images/rows.svg" />
                  </div>
                  <div
                    (click)="setView('condensed')"
                    class="filter-button cds-flex cds-flex-row cds-justify-center cds-items-center cds-rounded cds-px-[10px] cds-border cds-border-[#D7D7D7] cds-gap-[4px] cds-h-[46px]"
                    [ngClass]="viewType === 'condensed' ? 'cds-bg-[#e8e8e8]' : 'cd-bg-transparent'"
                  >
                    <img src="/images/drawer.svg" />
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
          <div>
            <table>
              <thead class="cds-whitespace-nowrap">
                    <tr>
                      @for (col of columns; track col.key) {
                        <th class="cds-cursor-pointer">
                          <div class="cds-flex cds-items-center cds-gap-2">
                            {{ col.label }}
                            <cb-icon
                              [iconKey]="'utility-sort'"
                            >
                            </cb-icon>
                          </div>
                        </th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (policy of filteredPolicies(); track policy.policy.number) {
                        <tr
                          class="row-hover cds-cursor-pointer"
                        >
                          <td>{{ policy.policy.adviserName }}</td>
                          <td>{{ policy.policy.adviserCode }}</td>
                          <td>{{ policy.policy.number }}</td>
                          <td>{{ policy.policy.productName }}</td>
                          <td>
                            {{
                              referenceDataService.getReferenceDataSetValue(
                                'coverageStatusCode',
                                policy.policy.statusCode
                              )
                            }}
                          </td>
                          <td>{{ policy.policy.lifeAssuredFullName }}</td>
                          <td>${{ policy.policy.pendingApiInclGst! / 100 | number: '1.2-2' }}</td>
                          <td>{{ policy.policy.anniversary }}</td>
                          <td [ngClass]="getDaysTextColor(policy.policy.pendingAgeDays!)">
                            @if (policy.policy.pendingAgeDays !== null) {
                              <div class="cds-flex cds-items-center cds-gap-2">
                                <span class="cds-inline-block cds-w-20"
                                  >{{ policy.policy.pendingAgeDays }} days</span
                                >
                                <span
                                  class="cds-inline-block cds-h-3 cds-w-3 cds-rounded-full"
                                  [ngClass]="showPill(policy.policy.pendingAgeDays!)"
                                ></span>
                              </div>
                            }
                          </td>
                        </tr>
                      }
                  </tbody>
            </table>
          </div>
    </div>
</div>